export default function applyDropdownFilters(obj) {
    const dropdownFilters = {};
    const dropdownSelects = document.querySelectorAll("#dropdown__filters select");
    dropdownSelects.forEach((select) => {
        const filter = convertDropdownFilterToFavoriteDataParam(select.id);
        // Only apply dropdown filters if the object doesn't already have them
        if (!obj.hasOwnProperty(filter)) {
            if (select.options[select.selectedIndex]) {
                // Apply a built-in option
                const val = select.options[select.selectedIndex].value;
                if (val) {
                    dropdownFilters[filter] = val;
                }
            }
            else if (select.options[0].value) {
                // Apply a custom option
                dropdownFilters[filter] = select.options[0].value;
            }
        }
    });
    // Custom data is combined into a single property
    if (!obj.hasOwnProperty("customer_data") && dropdownFilters.cdvar && dropdownFilters.cdvalue) {
        dropdownFilters.customer_data = [
            {
                name: dropdownFilters.cdvar,
                value: [dropdownFilters.cdvalue],
            },
        ];
    }
    // Clean up the unused custom data properties
    delete dropdownFilters.cdvar;
    delete dropdownFilters.cdvalue;
    return Object.assign(Object.assign({}, obj), dropdownFilters);
}
const dropdownFilterToFavoriteDataParamMap = {
    testprofile: "test_profile_name",
    testprofile_all: "test_profile_name",
    br: "test_profile_name",
    pl: "label",
    hn: "hostname",
    pn: "pathname",
    r: "region",
    co: "region",
    s: "site_ids",
    u: "label",
    l: "label",
};
function convertDropdownFilterToFavoriteDataParam(filter) {
    if (dropdownFilterToFavoriteDataParamMap[filter]) {
        return dropdownFilterToFavoriteDataParamMap[filter];
    }
    return filter;
}
